import React, { useEffect, useState } from "react";
import serviceApi from "../../../services/serviceApi";
import environment from "../../../environments/environment";
import schoolIcon from "../../../assets/school.png";

interface CirclePost {
    id: string;
    createdAt: string;
    title: string;
    text: string;
    image: string;
    video?: string;
    author?: string;
    category: string;
    type?: string;
    clss?: string;
    liked?: boolean;
}

const CirclePosts: React.FC = () => {

    const [posts, setPosts] = useState<CirclePost[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const [activeScope, setActiveScope] = useState("SCHOOL");
    const [activeCategory, setActiveCategory] = useState("KNOWLEDGE");

    const [showOverlayMenu, setShowOverlayMenu] = useState(false);
    const [selectedOverlayActionUI, setSelectedOverlayActionUI] = useState<string | null>(null);

    const overlayConfig: any = {
        know: { label: "Know", icon: "fa-book", color: "#43a047" },
        make: { label: "Make", icon: "fa-paint-brush", color: "#3d7eb1" },
        play: { label: "Play", icon: "fa-futbol", color: "#fb8c00" },
        fun: { label: "Fun", icon: "fa-laugh", color: "#e53935" }
    };
    useEffect(() => {
        fetchPosts();
    }, [activeScope, activeCategory]);

    const fetchPosts = async () => {
        setIsLoading(true);
        setError(null);

        try {
            const response = await serviceApi.get(
                `${environment.schoolCircle}?page=1&scope=${activeScope}&category=${activeCategory}`
            );

            if (response.status === "SUCCESS") {
                setPosts(response.dataList || response.listData || []);
            } else {
                setPosts([]);
            }

        } catch (err: any) {
            setPosts([]);
            setError(null);
        } finally {
            setIsLoading(false);
        }
    };

    const toggleLike = (id: string) => {
        setPosts(prev =>
            prev.map(p =>
                p.id === id ? { ...p, liked: !p.liked } : p
            )
        );
    };

    const toggleOverlayMenu = () => {
        setShowOverlayMenu(prev => !prev);
    };

    const selectOverlayAction = (action: string) => {
        setSelectedOverlayActionUI(action);
        setShowOverlayMenu(false);

        const map: any = {
            know: "KNOWLEDGE",
            make: "MAKE",
            play: "PLAY",
            fun: "FUN"
        };

        setActiveCategory(map[action]);
    };

    const activeOverlay = selectedOverlayActionUI
        ? overlayConfig[selectedOverlayActionUI]
        : null;

    return (
        <div
            onClick={() => showOverlayMenu && setShowOverlayMenu(false)}
            style={{ background: "#ededf5", minHeight: "100vh", position: "relative" }}
        >

            {/* ================= TOP SCOPE BAR ================= */}
            <div style={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                background: "white",
                padding: "10px 5px",
                position: "sticky",
                top: 0,
                zIndex: 10,
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
            }}>

                {[
                    {
                        label: "Inner",
                        value: "INNER",
                        icon: "fa-circle",
                        type: "icon",
                        color: "#43a047"
                    },

                    {
                        label: "Circle",
                        value: "SCHOOL",
                        icon: schoolIcon,
                        type: "image",
                        color: "#3d7eb1"
                    },

                    {
                        label: "Local",
                        value: "LOCAL",
                        icon: "fa-university",
                        type: "icon",
                        color: "#fb8c00"
                    },

                    {
                        label: "Global",
                        value: "GLOBAL",
                        icon: "fa-globe",
                        type: "icon",
                        color: "#e53935"
                    }
                ].map(item => (
                    <div
                        key={item.value}
                        onClick={() => setActiveScope(item.value)}
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            fontSize: 11,
                            cursor: "pointer",
                            color: activeScope === item.value ? item.color : "#888",
                            fontWeight: activeScope === item.value ? "bold" : "normal"
                        }}
                    >
                        <div
                            style={{
                                width: 34,
                                height: 34,
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginBottom: 4,
                                background: activeScope === item.value
                                    ? item.color + "20"
                                    : "transparent",
                                border: activeScope === item.value
                                    ? `2px solid ${item.color}`
                                    : "1px solid transparent"
                            }}
                        >
                            {item.type === "image" ? (
                                <img
                                    src={item.icon}
                                    style={{
                                        width: 20,
                                        height: 20,
                                        objectFit: "contain"
                                    }}
                                />
                            ) : (
                                <i
                                    className={`fa ${item.icon}`}
                                    style={{
                                        fontSize: 16,
                                        color: activeScope === item.value ? item.color : "#888"
                                    }}
                                />
                            )}
                        </div>
                        {item.label}
                    </div>
                ))}
            </div>

            {/* ================= CONTENT ================= */}
            <div style={{ padding: 10 }}>

                {isLoading && (
                    <div style={{ textAlign: "center" }}>
                        <i className="fa fa-spinner fa-spin"></i> Loading...
                    </div>
                )}

                {!isLoading && posts.length === 0 && (
                    <div style={{ textAlign: "center", color: "#888", marginTop: 20 }}>
                        No posts available
                    </div>
                )}

                {posts.map(post => (
                    <div key={post.id} style={{
                        background: "white",
                        marginBottom: 12,
                        borderRadius: 8,
                        overflow: "hidden",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                    }}>

                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "8px 10px",
                            fontSize: 12
                        }}>
                            <b style={{ color: "#333" }}>{post.title}</b>
                            <span><i className="fa-regular fa-clock colorOrange"></i>&nbsp;{post.createdAt}</span>
                        </div>

                        {post.image && <img src={post.image} style={{ width: "100%" }} />}
                        {post.video && <video src={post.video} controls style={{ width: "100%" }} />}

                        <div style={{ padding: 10 }}>{post.text}</div>

                        {/* ================= LIKE ================= */}
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "8px 10px",
                            borderTop: "1px solid #eee",
                            alignItems: "center"
                        }}>
                            <span style={{ fontSize: 12 }}>
                                #{post.type} {post.clss}
                                {post.author?.trim() && (
                                    <b style={{ marginLeft: 5, color: "#f39c12" }}>
                                        [{post.author}]
                                    </b>
                                )}
                            </span>

                            <div
                                onClick={() => toggleLike(post.id)}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 5,
                                    cursor: "pointer",
                                    color: post.liked ? "#1877f2" : "#888",
                                    fontWeight: 500
                                }}
                            >
                                <i className="fa fa-thumbs-up" />
                                Like
                            </div>
                        </div>

                    </div>
                ))}
            </div>

            {/* ================= FLOAT BUTTON ================= */}
            <div
                onClick={(e) => {
                    e.stopPropagation();
                    setShowOverlayMenu(prev => !prev);
                }}
                style={{
                    position: "fixed",
                    right: 0,
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: activeOverlay?.color || "#6a1b9a",
                    color: "white",
                    padding: "10px 8px",
                    borderTopLeftRadius: 10,
                    borderBottomLeftRadius: 10,
                    cursor: "pointer",
                    zIndex: 999,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    minWidth: 44
                }}
            >
                {/* INITIAL < ONLY, AFTER ICON ONLY */}
                {!selectedOverlayActionUI ? (
                    // <i className="fa-solid fa-angle-left" />
                    // <i className="fa-solid fa-wand-magic-sparkles" />
                    <i className="fa-solid fa-shuffle" />
                ) : (
                    <i className={`fa ${activeOverlay.icon}`} style={{ fontSize: 16 }} />
                )}
            </div>

            {/* ================= OVERLAY MENU ================= */}
            {showOverlayMenu && (
                <div
                    onClick={() => setShowOverlayMenu(false)}
                    style={{
                        position: "fixed",
                        right: 0,
                        top: "50%",
                        transform: "translateY(-50%)",
                        zIndex: 999
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            background: "white",
                            borderRadius: 10,
                            padding: 8,
                            display: "flex",
                            flexDirection: "column",
                            gap: 6,
                            boxShadow: "0 2px 10px rgba(0,0,0,0.2)"
                        }}
                    >
                        {Object.keys(overlayConfig).map(key => (
                            <div
                                key={key}
                                onClick={() => selectOverlayAction(key)}
                                style={{
                                    display: "flex",
                                    flexDirection: "column",   // ✅ IMPORTANT
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "10px",
                                    cursor: "pointer",
                                    borderRadius: 8,
                                    color: overlayConfig[key].color,
                                    minWidth: 70
                                }}
                            >
                                {/* ICON TOP */}
                                <i className={`fa ${overlayConfig[key].icon}`} style={{ fontSize: 18 }} />

                                {/* TEXT BOTTOM */}
                                <span style={{ fontSize: 11, marginTop: 4 }}>
                                    {overlayConfig[key].label}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default CirclePosts;